/** One duration for every panel motion: the column's width collapse/expand and the Notification Center card. */
export const SIDE_PANEL_TRANSITION_MS = 500;

/**
 * Inline duration for every panel transition, derived from
 * {@link SIDE_PANEL_TRANSITION_MS} so the CSS transitions and the stage hooks'
 * settle-timeout fallback cannot desync. A `duration-*` class literal would
 * restate the number, and Tailwind cannot build one from a variable.
 */
export const SIDE_PANEL_TRANSITION_DURATION_STYLE = {
  transitionDuration: `${SIDE_PANEL_TRANSITION_MS}ms`,
} as const;
